import API from '../AxiosInstance';

export default {
  getHomeTenantsList: function(rootNodeId) {
    const options = {};
    return API.get(`tenants/${rootNodeId}/connections/home`, options);
  },
  getAwayTenantsList: function(rootNodeId) {
    const options = {};
    return API.get(`tenants/${rootNodeId}/connections/away`, options);
  },

  requestTenantConnection: function(rootNodeId, payload) {
    return API.post(`tenants/${rootNodeId}/connections/request`, payload);
  },

  updateHomeTenantConnection: function(rootNodeId, connectionId, payload) {
    return API.patch(`tenants/${rootNodeId}/connections/home/${connectionId}`, payload);
  },

  removeTenantConnection: function(rootNodeId, connectionId) {
    return API.delete(`tenants/${rootNodeId}/connections/${connectionId}`);
  },

  completeTenantConnection: function(rootNodeId, payload) {
    return API.post(`tenants/${rootNodeId}/connections/complete`, payload);
  },

  awayTenantSaveGroups: function(rootNodeId, connectionId, payload) {
    return API.post(`tenants/${rootNodeId}/connections/away/${connectionId}/groups`, payload);
  },

  awayTenantGetUsers: function(rootNodeId, connectionId) {
    return API.get(`/tenants/${rootNodeId}/connections/away/${connectionId}/users`);
  },

  awayTenantUpdateUsers(rootNodeId, connectionId, payload) {
    return API.patch(`/tenants/${rootNodeId}/connections/away/${connectionId}/users`, payload);
  },
}
